var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 192H128c-35.3 0-64 28.7-64 64v512c0 35.3 28.7 64 64 64h576.6l191.6 127.7L896 832c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64z",
    fill: "#3D5AFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M640 512c0-125.4-51.5-238.7-134.5-320H128c-35.3 0-64 28.7-64 64v512c0 35.3 28.7 64 64 64h377.5c83-81.3 134.5-194.6 134.5-320z",
    fill: "#536DFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
    fill: "#FFFF8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
    fill: "#FFFF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M768 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
    fill: "#FFEA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.76d6a08547c9b1ea3ea601fe2d61bcc4.svg";
export { ForwardRef as ReactComponent };